export class ApiQueryType {
    public static strWayBillCode: string = "CODE0001";
    public static strPackageCode: string = "CODE0002";
    public static strCarCode: string = "CODE0004";
    public static strTimeValidCode: string = "CODE0007";
    public static strStationCode: string = "CODE0010";
    public static strLineCode: string = "CODE0021";
    public static strLineFrequencyCode: string = "CODE0022";
    public static strOperationFrequencyCode: string = "CODE0026";
    public static strAcceptTypeCode: string = "CODE0049";
    public static strSinatureCode: string = "CODE0020";
    public static strCarInfoCode: string = "CODE0018";
    public static strOperationAreaCode: string = "CODE0031";
}

export class UploadStateEnum {
    public static NotStarted: number = 0;//未上传
    public static Sucess: number = 1;//上传成功
    public static Fail: number = 2;//上传失败
    public static ModifySuccess: number = 3;//修改成功
    public static ModifyFail: number = 4;//修改失败
}

export class OpCodeEnum {
    public static aboard: number = 131;//上车
    public static debus: number = 171;//下车
    public static collect: number = 310;//揽收
    public static collectandabord: number = 310131;//揽发合一

    public static seal: number = 139;//封车扫描
    public static depart: number = 140;//发车扫描
    public static arrive: number = 160;//到车扫描
    public static resolve: number = 170;//解车扫描
}
export enum ModeType {

    FastHandOutputType = 1,
    DWSOutputType,
    CrazeScanOutputType,
    ManualScanOutputType,
    DWSOnlyCode,
    DWSCodeAndWeight,
    DWSCodeAndWeightVol
}
export enum ModeAddType {
    None = 0,
    Cross = 1,
    Swing = 2,
    ControlWeight = 4,
}
export enum GetonOrGetoff {
    GetOn,
    GetOff,
}
export enum TipVoiceLayerType {
    TipVoiceLayer1 = 1,
    TipVoiceLayer2,
    TipVoiceLayer3,
    TipVoiceLayer4,
    TipVoiceLayer5,
    TipVoiceLayer6,
    TipVoiceLayer7,
    TipVoiceLayer8,
    TipVoiceLayer9,
    TipVoiceLayer10
}
export enum NoticeVoiceType {
    OperSuccessVoice,
    OperFailVoice,
    RouteFailVoice,
    WarnVoice,
    PackFillVoice,
    WantedPackVoice,
    PauseVoice,
    StartByDVoice,
    ReturnVoice,
    ChangeAddressVoice,
    InterceptDeliveryVoice,
    DiscardVoice,
}
export enum ScanSysType {
    FastHand = 1,
    DWS,
    CrazeScan,
    ManuScan,
    DWSOnlyCode,
    DWSCodeAndWeight,
    DWSCodeAndWeightVol
}
export enum SendDataType {
    CodeValid,
    SuppleCode,
    handleNumber,
    EnumCamera,
    TestCamera,
    TestWeight,
    CrazyResualt,
    CloseServer,
    Watermark,
    PortData,
    ExceptionLatticeNo,
    NoticeDct //通知DCT事件
}

export enum ReceiveDataType {
    CameraState,
    PackageData,
    ErrorState,
    CodeCheck,
    TestCamera,
    EnumCamera,
    TestWeight,
    ErrorInfo,
    /// <summary>
    /// 陆海晶 2019年4月18日10:30:54  启用焦点屏蔽功能
    /// </summary>
    KillFocusDll,
    CodeUpload,
    OtherErrorInfo,
    PeelBtnInfo,//去皮信息
    TimeDetail,//各种时间点
    DropLatticeData,//落格数据,
    SixScanData = 14
}

export enum ErrorCode {
    NeedSuppleCode = 1,
    TooMuchCode,
    NoWeight,
    OverWeight,
    NoVolumn,
    TooLong,
    NoEntry,
    ClearState,
    Reset,
}

//新增库房声音，枚举值默认从20开始
export enum StoreRoomSound{
  StroeRoom1 = 21,
  StroeRoom2,
  StroeRoom3,
  StroeRoom4,
  StroeRoom5,
  StroeRoom6,
  StroeRoom7,
  StroeRoom8,
  StroeRoom9,
  CuoZhuang
}
export class WeighbridgeBll {
    public static IoStatusList = [{ key: "进场", value: "1" }, { key: "出场", value: "2" }, { key: "串行回磅", value: "3" }];
    public static DefaultWaybillNo = "666666666666";
    /// <summary>
    /// 车牌规则验证
    /// 车牌规则：总共7位（传统车牌）或者8位（新能源车牌）
    /// 1、首位必须是以下汉字之一【京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领】
    /// 2、第二位：A-Z的字母
    /// 3、3-7或者3-8位是由字母或者数字组合，但是没有字母“I”和“O”，最后一位可以是汉字“挂学警港澳使领”
    /// </summary>
    /// <param name="cp"></param>
    /// <returns></returns>
    public static RegularByCP(cp) {
        if (cp == null || cp == undefined || cp.length == 0) {
            return false;
        }
        if (cp.indexOf("I") != -1 || cp.indexOf("O") != -1) {
            return false;
        }
        // string patten = "^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-Z0-9]{4,5}[A-Z0-9挂学警港澳使领]$";
        // return Regex.IsMatch(cp, patten);
        var reg1 = new RegExp(/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-Z0-9]{4,5}[A-Z0-9挂学警港澳使领]$/);
        if (reg1.test(cp)) {
            return true;
        } else {
            return false;
        }
    }
}

export enum ElectronicScreenState {
    notConfigured = 0,
    connectSucceeded,
    connectFailed
}

export const errorMsgs:Map<number,string> = new Map();
errorMsgs[1] = '【1】请补条码-拒识'
errorMsgs[2] = '【1】请补条码-多条码'
errorMsgs[3] = '【2】重量/体积异常-无重量'
errorMsgs[4] = '【2】重量/体积异常-超重'
errorMsgs[5] = '【2】重量/体积异常-无体积'
errorMsgs[6] = '【2】重量/体积异常-体积超长'
errorMsgs[7] = '超时，包裹不准入'
